import { PropsWithChildren } from 'react';

import css from './styles.module.css';

export type CheckboxIconProps = PropsWithChildren;

/**
 * A decorative icon shown before the label text. Render it inside
 * `Checkbox.Label` so clicking it still toggles the control.
 */
export function CheckboxIcon({ children }: CheckboxIconProps) {
  return (
    <span className={css.icon} aria-hidden>
      {children}
    </span>
  );
}
